import React, { useContext, useEffect, useRef, useState } from "react";
import $ from "jquery";

import { useTranslation } from "react-i18next";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";

import jwtInterceoptor from "../../components/shared/jwtInterceptor";

import moment from "moment";

import Swal from "sweetalert2";

import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import OrgContext from "../../organisation/OrgContext";
import { API } from "../../services/api";
import { useNavigate } from "react-router-dom";
import { frFR, enUS } from "@mui/x-data-grid";
import { LinearProgress } from "@mui/material";
import useAuthHelper from "../../helpers/AuthHelper";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          x
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

function ListPieces(props) {
  const [t, i18n] = useTranslation();

  const { organisation } = useContext(OrgContext);

  const [pieces, setPieces] = useState([]);

  const [currentSelectedInvoice, setCurrentSelectedInvoice] = useState(0);
  const navigate = useNavigate();

  const [loadingData, setLoadingData] = useState(false);
  const { onlyComptable } = useAuthHelper();
  useEffect(() => {
    onlyComptable();
    if (organisation.id) {
      fetchPieces();
    }
  }, []);
  const fetchPieces = async () => {
    setLoadingData(true);
    const response = await jwtInterceoptor.get(
      `/data/user/piece/get/${organisation.id}`
    );

    if (response.status === 200) {
      setPieces(response.data.data);
    }
    setLoadingData(false);
  };

  const deleteItem = async (inv) => {
    Swal.fire({
      title: t("Are you sure?"),
      text: t("You won't be able to revert this!"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: t("Yes, delete it!"),
      cancelButtonText: t("Cancel"),
    }).then(async (result) => {
      if (result.isConfirmed) {
        const response = await jwtInterceoptor.delete(
          `/data/user/piece/delete/${inv.id}`
        );

        if (response.status === 200) {
          if (response.data.status == true) {
            let invs = pieces.filter((el) => el.id != inv.id);
            setPieces(invs);
            Swal.fire(
              t("Deleted!"),
              t("Your record has been deleted."),
              "success"
            );
            return;
          }
        }

        Swal.fire({
          icon: "warning",
          title: "",
          text: t("Something went wrong!, try again"),
        });
      }
    });
  };

  const formatNumber = (number) => {
    let result = number.toString().padStart(6, "0");
    return result;
  };

  const columns = [
    {
      flex: 1,
      field: "Journal",
      headerName: t("Journal"),
      valueGetter: (params) => params.row.journal,
    },
    {
      flex: 1,
      field: "Libelle",
      headerName: t("Libelle"),
      valueGetter: (params) => params.row.libelle,
    },
    {
      flex: 1,
      field: "Date de création",
      headerName: t("Date de création"),
      valueGetter: (params) =>
        `${moment(params.row.created_at).format("DD/MM/YYYY") || ""}`,
    },
    {
      flex: 1,
      field: "Total débit",
      headerName: t("Total débit"),
      valueGetter: (params) =>
        Number(params.row.total_debit).toFixed(2) + " " + organisation?.currency?.code,
    },
    {
      flex: 1,
      field: "Total Crédit",
      headerName: t("Total Crédit"),
      valueGetter: (params) =>
        Number(params.row.total_credit).toFixed(2) + " " + organisation?.currency?.code,
    },
    {
      field: "Actions",
      headerName: t("Actions"),
      width: 180,
      sortable: false,
      disableClickEventBubbling: true,

      renderCell: (params) => {
        const onDelete = (e) => {
          const inv = params.row;
          return deleteItem(inv);
        };

        const onEditInvoice = (e) => {
          const inv = params.row;
          navigate(`/piece/edit/${inv.id}`);
        };

        const onDetails = (e) => {
          const inv = params.row;
          navigate(`/piece/details/${inv.id}`);
        };

        return (
          <div className="btn-list">
            <button
              onClick={onEditInvoice}
              id="bEdit"
              type="button"
              className="btn  btn-sm btn-primary"
              title={'Modifier'}
            >
              <span className="fe fe-edit"> </span>
            </button>
            <button
              onClick={onDetails}
              id="bEdit"
              type="button"
              className="btn  btn-sm btn-secondary"
              title={'Voir le dètails'}
            >
              <span class="fe fe-eye"> </span>
            </button>
            <button
              onClick={onDelete}
              id="bDel"
              type="button"
              className="btn  btn-sm btn-danger"
              title={'Supprimer'}
            >
              <span className="fe fe-trash-2"> </span>
            </button>
          </div>
        );
      },
    },
  ];

  return (
    <>
      <div className="row" style={{ zIndex: 1 }}>
        <div className="col-lg-12">
          <div className="card">
            <div className="card-header container-fluid row">
              <div className="col-md-9 col-sm-12 card-title">
                {t("Gestion des pièces")}
              </div>
              <div className="col-md-3 card-title d-flex justify-content-end">
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    navigate("/piece/add");
                  }}
                >
                  Ajouter une Pièce
                </button>
              </div>
            </div>
            <div className="card-body">
              <div className="table-responsive">
                <div style={{ height: 400, width: "100%" }}>
                  <DataGrid
                    rows={pieces}
                    columns={columns}
                    pagination={false}
                    localeText={
                      i18n.language == "fr"
                        ? frFR.components.MuiDataGrid.defaultProps.localeText
                        : enUS.components.MuiDataGrid.defaultProps.localeText
                    }
                    slotProps={{
                      toolbar: {
                        printOptions: { disableToolbarButton: true },
                        csvOptions: { disableToolbarButton: true },
                      },
                    }}
                    slots={{
                      loadingOverlay: LinearProgress,
                      toolbar: GridToolbar,
                    }}
                    loading={loadingData}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ListPieces;
